import { DateSpan } from "@framework";
import styles from './ApplicationVersionHistory.module.css'
import { Icon } from "semantic-ui-react";
import { formatNumber } from "shared/utils";
import { useTranslation } from "@hooks/useTranslation";
import { IApplicationVersion } from "api";
import { useState } from "react";
import { useSubmittedApplicationStatus } from "../useSubmittedApplicationStatus";

interface ApplicationVersionHistoryProps {
    applicationVersions: IApplicationVersion[] | undefined
}

export function ApplicationVersionHistory(props: ApplicationVersionHistoryProps) {
    return (
        <div className={styles["versions-container"]}>
            {props.applicationVersions?.map((version, idx) => (
                <ApplicationVersionHistoryItem
                    key={version.savedApplicationId}
                    version={version}
                    idx={idx}
                />
            ))}
        </div>
    )
}

function ApplicationVersionHistoryItem({ version, idx }: { version: IApplicationVersion, idx: number }) {
    const submittedApplicationStatus = useSubmittedApplicationStatus()
    const $t = useTranslation('SubmittedApplicationPage')
    const [detailsVisible, setDetailsVisible] = useState(false)
    const isCurrentVersion = idx === 0

    const showDetails = () => {
        setDetailsVisible(!detailsVisible)
    }

    const detailsItem = (label: string, value: string | number) => <div className={styles["details-item"]}>
        <label>{label}</label>
        <div>{value}</div>
    </div>

    return (
        <div key={version.savedApplicationId} className={styles["version-item"]}>
            <div className={styles["version-info"]} onClick={showDetails}>
                <div className={`${styles["version-info-item"]} ${styles["version-status"]}`}>
                    <strong>{submittedApplicationStatus.description(version.status)}</strong>
                </div>
                <div className={styles["version-info-item"]}>
                    <DateSpan value={version.created}></DateSpan>
                </div>
                <div className={styles["version-info-item"]}>
                    {version.sellerFirstName} {version.sellerLastName}
                </div>
                <div className={`${styles["version-info-item"]} ${styles["version-info-tag"]}`}>
                    <div className={`${styles["version-tag"]} ${isCurrentVersion ? styles["version-tag-current"] : styles["version-tag-previous"]}`}>
                        {isCurrentVersion ? $t('CurrentVersion') : $t('PreviousVersion')}
                    </div>
                    {detailsVisible ? <Icon name="angle up" /> : <Icon name="angle down" />}
                </div>
            </div>
            <div className={`${styles["version-details"]} ${detailsVisible ? styles["version-details-visible"] : styles["version-details-hidden"]}`}>
                <div>
                    {detailsItem($t('Price'), `kr. ${formatNumber(version.objectPrice)}`)}
                    {detailsItem($t('Security Amount'), `kr. ${formatNumber(version.downPayment)}`)}
                </div>
                <div>
                    {detailsItem($t('Needs Amount'), `kr. ${formatNumber(version.financedAmount)}`)}
                    {detailsItem($t('monthlyPayment'), `kr. ${formatNumber(version.monthlyPayment)}`)}
                </div>
                <div>
                    {detailsItem($t('interestRate'), `${formatNumber(version.interestRate)} %`)}
                    {detailsItem($t('No Of Terms'), version.numberOfTerms)}
                </div>
            </div>
        </div>
    )
}